<template>
  <v-card style="margin: 0;padding: 0;">
    <v-card-title primary-title style="margin: 0;padding:0 5px;">
      <v-subheader>基本属性</v-subheader>
    </v-card-title>
    <v-container grid-list-md>
      <v-layout row wrap>
        <v-flex xs12 sm12 md6 lg4 xl3>
          <v-text-field v-model.number="model.minValue" label="最小值"></v-text-field>
        </v-flex>
        <v-flex xs12 sm12 md6 lg4 xl3>
          <v-text-field v-model.number="model.maxValue" label="最大值"></v-text-field>
        </v-flex>
        <v-flex xs12 sm12 md6 lg4 xl3>
          <v-text-field v-model.number="model.step" label="步进"></v-text-field>
        </v-flex>
      </v-layout>
    </v-container>
  </v-card>
</template>

<style scoped>

</style>

<script>
  import NumberProperty from "./numberProperty.ts";
  export default NumberProperty;
</script>